import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('@views/main/report-page/report-page.component').then(m => m.ReportPageComponent)
    }
];
